import { useDispatch } from 'react-redux';
import { CategoriesBannerWithLoader } from './loaders';

export const BannerCategories = () => {
    const dispatch = useDispatch();

    return <CategoriesBannerWithLoader />;
};
